import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { History } from "lucide-react";
import ExportRangeDialog from "@/components/ExportRangeDialog";

const KINDS = [
  { v: "", label: "All" }, { v: "member", label: "Members" }, { v: "attendance", label: "Attendance" },
  { v: "fee_payment", label: "Fees" }, { v: "ledger", label: "Ledger" }, { v: "camp", label: "Camps" }, { v: "user", label: "Users" },
];
const KIND_TAG = {
  member: "bg-green-100 text-green-800", attendance: "bg-sky-100 text-sky-800", fee_payment: "bg-amber-100 text-amber-800",
  ledger: "bg-emerald-100 text-emerald-800", camp: "bg-violet-100 text-violet-800", user: "bg-slate-200 text-slate-800",
};

const fmt = (iso) => {
  const d = new Date(iso);
  return `${d.toLocaleDateString("en-IE", { day: "numeric", month: "short" })} ${d.toLocaleTimeString("en-IE", { hour: "2-digit", minute: "2-digit" })}`;
};

export default function ActivityLog() {
  const [kind, setKind] = useState("");
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/admin/activity", { params: { limit: 100, ...(kind ? { kind } : {}) } }).then((r) => setItems(r.data)).catch(() => setItems([]));
  }, [kind]);

  return (
    <Card className="card-shadow-soft" data-testid="activity-log">
      <CardHeader>
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <CardTitle className="text-lg flex items-center gap-2"><History className="w-5 h-5 text-primary" /> Activity log</CardTitle>
          <div className="flex flex-wrap items-center gap-1">
            {KINDS.map((k) => (
              <Button key={k.v} size="sm" variant={kind === k.v ? "default" : "outline"} data-testid={`activity-filter-${k.v || "all"}`} onClick={() => setKind(k.v)}>{k.label}</Button>
            ))}
            <ExportRangeDialog path={kind ? `/export/activity.csv?kind=${kind}` : "/export/activity.csv"} filenameBase={kind ? `activity-${kind}` : "activity"} testid="export-activity-btn" label="Export" />
          </div>
        </div>
      </CardHeader>
      <CardContent>
        {items.length === 0 && <p className="text-sm text-muted-foreground" data-testid="activity-empty">No activity recorded yet.</p>}
        <ol className="relative border-l border-border ml-2 space-y-3">
          {items.map((a, i) => (
            <li key={`${a.at}-${i}`} data-testid="activity-item" className="ml-4 text-sm">
              <span className="absolute -left-[5px] mt-1.5 w-2.5 h-2.5 rounded-full bg-primary" />
              <div className="text-xs text-muted-foreground">{fmt(a.at)}</div>
              <div>
                <span className="font-semibold">{a.user_name}</span> {a.action} <span className={`scout-tag ${KIND_TAG[a.kind] || "bg-secondary"}`}>{a.kind.replace("_", " ")}</span> <span className="font-medium">{a.label}</span>
                {a.detail && <span className="text-muted-foreground"> — {a.detail}</span>}
              </div>
            </li>
          ))}
        </ol>
      </CardContent>
    </Card>
  );
}
